<div class="button-position flex-row gap-10">
  <button
    class="mat-elevation-z0"
    mat-mini-fab
    matRipple
    matRippleColor="white"
    color="primary"
    [disabled]="disableZoomIn"
    (click)="scaleChart(ZoomDir.In)"
    >
    <mat-icon class="button">add</mat-icon>
  </button>
  <button
    class="mat-elevation-z0"
    mat-mini-fab
    matRipple
    matRippleColor="white"
    color="primary"
    [disabled]="disableZoomOut"
    (click)="scaleChart(ZoomDir.Out)"
    >
    <mat-icon class="button">remove</mat-icon>
  </button>
</div>

@if (!isRendering && lineChartData) {
  <colimo-canvas-wrapper [chartType]="chartType" [quadrant]="quadrant">
  <canvas #chartMWG height="160"></canvas>
</colimo-canvas-wrapper>
}
